<template>
  <!-- dialog confirm request order / teruskan pesanan -->
  <div>  
    <v-dialog
      v-model="dialogConfirmRequestOrder"
      persistent
      scrollable
      max-width="80%"
    >
      <template v-if="!loading">
        <v-card style="width: 100%">
          <v-card-title class="text-h6 text-h6 text-capitalize green--text">
            <span>Konfirmasi Teruskan Pesanan</span>
          </v-card-title>
          <v-card-text class="pt-2 pb-0 px-5 mx-1 text-center" v-if="Object.keys(detail).length > 0">
            <v-row>
              <v-col cols="12" md="8">
                <!-- informasi order -->
                <v-card elevation="0" outlined class="pa-3">
                  <v-card-subtitle class="px-0 pt-0 font-weight-bold d-flex flex-start black--text">Data Pesanan</v-card-subtitle>
                  <v-card-text class="pa-0">
                    <v-row>
                      <v-col cols="12" md="6" class="pa-0">
                        <v-row>
                          <v-col cols="5" sm="5" class="pt-0 text-right"><label style="font-weight: bold;">Pembeli</label></v-col>
                          <v-col cols="7" sm="7" class="pt-0 text-left">{{ detail.buyer_name | emptyData }}</v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="5" sm="5" class="pt-0 text-right"><label style="font-weight: bold;">Stockist Dropship</label></v-col>
                          <v-col cols="7" sm="7" class="pt-0 text-left">{{ detail.trx_dropship_default_store.store_name | emptyData }}<br>({{ detail.trx_dropship_default_store.store_city_name + ', ' + detail.trx_dropship_default_store.store_province_name  }})</v-col>
                        </v-row>
                      </v-col>
                      
                      <v-col cols="12" md="6" class="pa-0">
                        <v-row>
                          <v-col cols="5" sm="5" class="pt-0 text-right"><label style="font-weight: bold;">No. Transaksi</label></v-col>
                          <v-col cols="7" sm="7" class="pt-0 text-left">{{ detail.trx_code | emptyData }}</v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="5" sm="5" class="pt-0 text-right"><label style="font-weight: bold;">Tanggal Transaksi</label></v-col>
                          <v-col cols="7" sm="7" class="pt-0 text-left">{{ detail.trx_datetime | tanggaljam }}</v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- informasi detail pesanan -->
                <v-card elevation="0" outlined class="pa-3 mt-3">
                  <v-card-text class="pa-0">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Kode Produk</th>
                            <th class="text-left">Nama Produk</th>
                            <th class="text-center">Jumlah</th>
                            <th class="text-right">Harga Jual Dasar</th>
                            <th class="text-right">Harga Beli</th>
                            <th class="text-right">Subtotal Margin</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, idx) in detail.trx_detail"
                            :key="idx"
                          >
                            <td class="text-left">{{ item.product_ref_code }}</td>
                            <td class="text-left">{{ item.trx_detail_product_name }}</td>
                            <td class="text-centert">{{ item.trx_detail_quantity }}</td>
                            <td class="text-right">{{ item.trx_detail_product_price_origin | toRupiah }}</td>
                            <td class="text-right">{{ item.trx_detail_product_price_dropship | toRupiah }}</td>
                            <td class="text-right">{{ item.trx_detail_product_price_diff | toRupiah }}</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr style="background: #f2f2f2; font-size: 16px;">
                            <th colspan="5" class="text-right">Total Margin Produk</th>
                            <th class="text-right">{{ detail.trx_total_diff | toRupiah }}</th>
                          </tr>
                        </tfoot>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                </v-card>

                <!-- informasi stok -->
                <v-card elevation="0" outlined class="pa-3 mt-3">
                  <v-card-text class="pa-0 text-left">
                    Informasi Stok: <strong class="pl-3" :class="(detail.trx_totak_stock) ? 'primary--text' : 'red--text'">{{ (detail.trx_totak_stock) ? 'Tersedia' : 'Tidak Tersedia' }}</strong>
                  </v-card-text>
                </v-card>

                <!-- informasi origin & pengiriman -->
                <v-row>
                  <v-col cols="12" md="6" class="py-0">
                    <v-card elevation="0" outlined class="pa-3 mt-3">
                      <v-card-subtitle class="px-0 pt-0 font-weight-bold d-flex flex-start black--text">Alamat Pengiriman</v-card-subtitle>
                      <v-card-text class="pa-0 text-left">
                        <div class="d-flex flex-column">
                          <strong class="text-capitalize">{{ detail.trx_shipping.trx_shipping_courier_receiver_name }} ({{ detail.trx_shipping.trx_shipping_courier_receiver_phone }})</strong>
                          <span class="d-block mt-1 text-capitalize">{{ addressText(detail.trx_shipping) }}</span>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6" class="py-0">
                    <v-card elevation="0" outlined class="pa-3 mt-3">
                      <v-card-text class="pa-0 text-left">
                        <v-card-subtitle class="px-0 pt-0 font-weight-bold d-flex flex-start black--text">Data Kurir</v-card-subtitle>
                        <div class="d-flex flex-row align-start">
                          <div class="mr-3"><v-img height="60" max-width="60" width="auto" contain position="left center" :src="(detail.trx_shipping.trx_shipping_courier_logo_url) ? detail.trx_shipping.trx_shipping_courier_logo_url : '/assets/product/default.png'"></v-img></div>
                          <div class="d-flex flex-column">
                            <div class="mb-1 px-2 font-weight-bold">{{detail.trx_shipping.trx_shipping_courier_name}} - {{detail.trx_shipping.trx_shipping_courier_service}}</div>
                            <div class="mb-1 px-2 font-weight-bold">{{detail.trx_shipping.trx_shipping_courier_total_price | toRupiah}}</div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>

              <!-- change dropship -->
              <v-col cols="12" md="4">
                <v-card elevation="0" outlined class="pa-3" color="#ddd">
                  <v-card elevation="0" outlined class="pa-3">
                    <v-card-subtitle class="px-0 pt-0 font-weight-bold d-flex flex-start black--text">Ubah Stockist Dropship</v-card-subtitle>
                    <v-card-text class="pa-0 text-left">
                      <v-autocomplete
                        :rules="storePartnerId"
                        v-model="dropshipPartnertId"
                        :items="dropshipdata.lists"
                        item-value="store_id"
                        item-text="store_name"
                        placeholder="Pilih Stokis Anda"
                        hide-details="auto"
                        :auto-select-first="true"
                        outlined
                        dense
                        @change="changeDropship()"
                      ></v-autocomplete>
                        <!-- @focus="() => responseError.store_product_product_id == ''" -->
                        <!-- :error-messages="responseError.store_product_product_id" -->
                    </v-card-text>
                  </v-card>

                  <v-card elevation="0" outlined class="pa-3 mt-3 font-size-12" v-if="Object.keys(selectedDropship).length > 0">
                    <v-card-text class="pa-0 text-left">
                      <v-row>
                        <v-col cols="12" md="6" class="pt-0">
                          <v-row>
                            <v-col cols="12" sm="12" class="pt-0 text-left pb-0 font-size-12"><label style="font-weight: bold;">Stok Produk</label></v-col>
                            <v-col cols="12" sm="12" class="pt-0 text-left primary--text font-size-12"><strong class="" :class="(selectedDropship.stock) ? 'primary--text' : 'red--text'">{{ (selectedDropship.stock) ? 'Tersedia' : 'Tidak Tersedia' }}</strong></v-col>
                          </v-row>
                        </v-col>

                        <v-col cols="12" md="6" class="pt-0">
                          <v-row>
                            <v-col cols="12" sm="12" class="pt-0 text-left pb-0 font-size-12"><label style="font-weight: bold;">Total Margin Produk ({{ getHDText(selectedDropship.store_price_category) }})</label></v-col>
                            <v-col cols="12" sm="12" class="pt-0 text-left font-size-12">{{ selectedDropship.diff | toRupiah }}</v-col>
                          </v-row>
                        </v-col>

                        <v-col cols="12" md="6" class="pt-0">
                          <v-row>
                            <v-col cols="12" sm="12" class="pt-0 text-left pb-0 font-size-12"><label style="font-weight: bold;">Asal Pengiriman</label></v-col>
                            <v-col cols="12" sm="12" class="pt-0 text-left pb-0 font-size-12">{{ (selectedDropship.store_city_name) ? selectedDropship.store_city_name : '-' }}{{ (selectedDropship.store_province_name) ? ', '  + selectedDropship.store_province_name : '' }}</v-col>
                          </v-row>
                        </v-col>

                        <v-col cols="12" md="6" class="pt-0">
                          <v-row>
                            <v-col cols="12" sm="12" class="pt-0 text-left pb-0 font-size-12"><label style="font-weight: bold;">Tujuan Pengiriman</label></v-col>
                            <v-col cols="12" sm="12" class="pt-0 text-left pb-0 font-size-12">{{ detail.trx_shipping.trx_shipping_courier_destination_city_name }}, {{ detail.trx_shipping.trx_shipping_courier_destination_province_name }}</v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <v-card elevation="0" outlined class="pa-3 mt-3">
                    <v-card-subtitle class="px-0 py-0 font-weight-bold d-flex flex-start black--text">Pengiriman</v-card-subtitle>
                    <v-card-text class="pa-0 text-left" v-if="Object.keys(selectedCourier).length > 0">
                      <v-row>
                        <v-col cols="12" md="3" class="pb-0">
                          <v-img height="60" max-width="60" width="auto" contain position="left center" :src="(selectedCourier.logistic_logo_url) ? selectedCourier.logistic_logo_url : '/assets/product/default.png'"></v-img>
                        </v-col>
                        <v-col cols="12" md="9" class="d-flex flex-column pb-0">
                          <label style="font-weight: bold;" class="mb-50">{{ selectedCourier.logistic_name }} - {{ selectedCourier.rate_name }}</label>
                          <!-- <span class="d-block mb-50">2 Hari</span> -->
                          <span class="d-block green--text" style="font-weight: bold;">{{ selectedCourier.price | toRupiah }}</span>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-text class="pa-4 text-center text-muted" v-else>
                      Silahkan pilih pengiriman terlebih dahulu
                    </v-card-text>
                    <v-card-text class="pb-2">
                      <v-btn
                        block
                        outlined
                        color="primary"
                        class="mt-2 text-capitalize"
                        :loading="loadingCourier"
                        :disabled="selectedDropship.store_city_name == null || selectedDropship.store_province_name == null"
                        @click="getDropshipCourierList()"
                      >
                        {{ (Object.keys(selectedCourier).length > 0) ? 'Ganti Pengiriman' : 'Pilih Pengiriman' }}
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="mt-3">
            <v-spacer></v-spacer>
            <v-row class="text-center">
              <v-btn
                outlined
                class="my-2 px-5 text-capitalize"
                :loading="loadingStatus"
                @click="dialogConfirmRequestOrder = false, selectedItem = null, loadingCourier = false"
              >
                Batal Teruskan Pesanan
              </v-btn>
              <v-btn
                color="green"
                :loading="loadingStatus"
                class="my-2 px-5 ml-2 text-capitalize white--text font-weight-bold"
                @click="prosesForwardPesananAct()"
              >
                Proses Teruskan Pesanan
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>

      </template>
    </v-dialog>
    <ModalCourier ref="modalCourier" :courier="dropshipCourier" :loading="loadingCourier" @action="selectCourierData"></ModalCourier>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ModalCourier from './ModalCourier'
export default {
  components: { ModalCourier },
  props: {
    dropshipdata: {
      type: Object,
      default() {
        return {}
      }
    },
    detail: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      loadingStatus: false,
      loadingCourier: false,
      dialogConfirmRequestOrder: false,
      dropshipPartnertId: '',
      selectedDropship: {},
      selectedCourier: {},
      storePartnerId: [
        v => !!v || 'Pilih stokist terlebih dahulu',
      ],
    }
  },
  watch: {
    detail(val) {
      if (val) {
        this.dropshipPartnertId = val.trx_dropship_default_store.store_id
        this.initSelectedCourier()
      }
    }
  },
  computed: {
    ...mapState('transaksiDropship', ['dropshipCourier']),
  },
  methods: {
    ...mapActions('transaksiDropship', ['getDropshipCourier']),

    async modalShow() {
      this.loading = await true
      if (Object.keys(this.detail).length > 0) {
        this.dropshipPartnertId = await this.detail.trx_dropship_default_store.store_id
        this.getSelectedDropship(this.detail.trx_dropship_default_store.store_id)
        this.initSelectedCourier()
      }

      setTimeout(() => {
        this.loading = false
        this.dialogConfirmRequestOrder = true
      }, 1000);

		},
    modalHide() {
			this.dialogConfirmRequestOrder = false
		},
    prosesForwardPesananAct() {
      // console.log(this.selectedCourier)
      const params = {
        trx_id: this.detail.trx_id,
        store_id: this.selectedDropship.store_id,
        trx_shipping_cost: this.selectedCourier.price,
        trx_shipping_courier_name: this.selectedCourier.logistic_name,
        trx_shipping_courier_service: this.selectedCourier.rate_name,
        trx_shipping_courier_weight: this.selectedCourier.weight,
        trx_shipping_courier_note: '',
        trx_shipping_courier_rate_code: this.selectedCourier.rate_code, 
        trx_shipping_courier_min_duration: this.selectedCourier.min_duration,
        trx_shipping_courier_max_duration: this.selectedCourier.max_duration
      }
      this.$emit('action', params)
    },
    addressText(value) {
      var data = []
			if (value.trx_shipping_courier_destination_address)
      data.push(value.trx_shipping_courier_destination_address)
			if (value.trx_shipping_courier_destination_sub_district_name)
      data.push(value.trx_shipping_courier_destination_sub_district_name)
			if (value.trx_shipping_courier_destination_district_name)
      data.push(value.trx_shipping_courier_destination_district_name)
			if (value.trx_shipping_courier_destination_city_name)
      data.push(value.trx_shipping_courier_destination_city_name)
			if (value.trx_shipping_courier_destination_province_name)
      data.push(value.trx_shipping_courier_destination_province_name)
      
			return data.join(', ')
		},
    getHDText(hd) {
      let hdtext = ''
      if (hd) hdtext = 'HD-' + hd.split('hd')[1]
      return hdtext
    },
    getSelectedDropship(id) {
      if (this.dropshipdata.lists.length > 0) {
        const dropship = this.dropshipdata.lists.find(x => x.store_id == id)
        this.selectedDropship = (dropship !== undefined) ? dropship : {}
      }
    },
    changeDropship() {
      if (this.dropshipdata.lists.length > 0) {
        this.selectedDropship = this.dropshipdata.lists.find(x => x.store_id == this.dropshipPartnertId)
        this.selectedCourier = {}
      }
    },
    showModalCourier() {
			this.$refs.modalCourier.modalShow()
		},
    async getDropshipCourierList() {
      this.loadingCourier = await true
      let params = await {
        trx_id: this.detail.trx_id,
        store_id: this.dropshipPartnertId,
        // weight: Math.ceil(this.detail.trx_shipping_weight / 1000)
        weight: this.detail.trx_shipping_weight / 1000
      }

      this.getDropshipCourier(params)
      .then(() => {
        if (Object.keys(this.dropshipCourier).length > 0) this.showModalCourier()
        setTimeout(() => {
          this.loadingCourier = false
        }, 300);
      })
      .catch(() => {
        this.loadingCourier = false
      })
    },
    selectCourierData(data) {
      this.selectedCourier = data
    },
    initSelectedCourier() {
      this.selectedCourier = {
        duration_type: null,
        insurance_price: 0,
        is_available_pickup_today: false,
        logistic_logo_url: this.detail.trx_shipping.trx_shipping_courier_logo_url,
        logistic_name: this.detail.trx_shipping.trx_shipping_courier_name,
        max_duration: this.detail.trx_shipping.trx_shipping_courier_max_duration,
        min_duration: this.detail.trx_shipping.trx_shipping_courier_min_duration,
        name: '',
        price: this.detail.trx_shipping.trx_shipping_courier_total_price,
        rate_code: this.detail.trx_shipping.trx_shipping_courier_rate_code,
        rate_name: this.detail.trx_shipping.trx_shipping_courier_service,
        signed_key: '',
        volume_weight: 0,
        weight: this.detail.trx_shipping.trx_shipping_courier_weight,
      }
    }
  },
  async mounted() {
    // console.log('dropshipdata', this.dropshipdata)
    this.loading = await true
    if (Object.keys(this.detail).length > 0) {
      this.dropshipPartnertId = await this.detail.trx_dropship_default_store.store_id
      this.getSelectedDropship(this.detail.trx_dropship_default_store.store_id)
      this.initSelectedCourier()
    }

    setTimeout(() => {
      this.loading = false
    }, 1000);
  },
}
</script>